import ServicesServiceList from './ServicesServiceList';

export { type ServicesServiceListProps } from './ServicesServiceList';
export default ServicesServiceList;
